import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bc9f9a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("li", {
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openSubmenu && _ctx.openSubmenu(...args))),
    class: _normalizeClass({'--active': _ctx.isActive})
  }, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode(_Transition, { name: "transition-fade-down" }, {
      default: _withCtx(() => [
        (_ctx.isActive)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeSubMenu && _ctx.closeSubMenu(...args)), ["stop"])),
              class: "oxd-calendar-dropdown",
              role: "menu"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  ref: `oxd-cal-ref-${index}`,
                  class: _normalizeClass({
            'oxd-calendar-dropdown--option': true,
            '--selected': index === _ctx.selected,
          }),
                  key: `oxd-cal-option-${index}`,
                  onClick: ($event: any) => (_ctx.onSelectOption(index))
                }, _toDisplayString(option), 11, _hoisted_1))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2)), [
    [_directive_click_outside, _ctx.closeSubMenu]
  ])
}